/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useLayoutEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import classes from "./index.module.scss";
import { isAuthenticated } from "helper";
import ToolBar from "components/ToolBar";
import SideMenu from "components/SideMenu";
import { useMediaQuery } from "hooks/useMediaQuery";
import { ReactComponent as FABChat } from "../../assets/svgs/FABChat.svg";
import OnahButton from "components/OnahButton";
import classNames from "classnames";
import { FullLoader } from "components/Loader";
import { useOnahDispatch, useOnahSelector } from "store/hooks";
import { getUserProfile } from "store/slices/user";
import { orderCount } from "store/slices/transaction";

type Props = {};

const DashboardLayout = (props: Props) => {
  let isTablet = useMediaQuery("(max-width: 1024px)", window.innerWidth <= 1024);
  const [open, setOpen] = useState(isTablet ? false : true);
  const dispatch = useOnahDispatch();
  const {completionPercentage} = useOnahSelector(state => state.onboarding);
  
  useLayoutEffect(() => {
    if (isAuthenticated()) {
     dispatch(getUserProfile());
     dispatch(orderCount());
      // any data generally needed can always be fetched on layout change
    }
  }, []);

  return (
    <div className={classes.main__layout}>
      <ToolBar progress={completionPercentage} setOpen={setOpen} />
      <div className={classes.layout__body}>
        <SideMenu
          className="fixed lg:sticky top-0"
          open={open}
          setOpen={setOpen}
          isTablet={isTablet}
        />
        <main className={classes.layout__outlet}>
          {/* FIXME: remove flex flex-col */}
          <div className="bg-white rounded-[32px] max-2xl:rounded-xl pt-[56px] max-2xl:pt-[36px] px-8 pb-5 mb-14 min-h-[calc(100%-1.25rem)] flex flex-col">
            {/* FIXME: remove flex flex-col flex-1 */}
            <div className="w-[100%] mx-auto max-w-[1048px] flex flex-col flex-1">
              <Suspense fallback={<FullLoader className="h-[calc(100%-1.25rem)]"/>}>
                <Outlet />
              </Suspense>
            </div>
          </div>
          <OnahButton
            className={classNames(
              "fixed bottom-4 right-4 !bg-black/75 hover:!bg-black hover:!opacity-100 text-white text-lg  ",
              "max-2xl:text-base w-[207px] max-2xl:w-[180px] gap-2 rounded-lg shadow-lg flex items-center justify-center font-acorn"
            )}
          >
            <FABChat />
            Contact Support
          </OnahButton>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
